import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Input } from 'components'
import styles from './index.module.css'

const FincarSearchEnter = () => {

	const App = useApp()
	const [tabMenu, setTabMenu] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" />,
			right: undefined,
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pt_30 pb_50">
					<h3>차량조회</h3>
					<ul className="tab-round-box mt_30">
						<li onClick={() => setTabMenu(0)} className={tabMenu === 0 ? "on" : ""}>직접입력</li>
						<li onClick={() => setTabMenu(1)} className={tabMenu === 1 ? "on" : ""}>필터검색</li>
					</ul>
					<div className="flex-align_center mt_40">
						<i className={`checkMark`} />
						<span className="ml_10">차량번호로 검색</span>
					</div>

					{/* 검색 영역 */}
					<div className="form-group search-bar mt_20">
						<Input style={{ background: "#fff" }} placeholder="제조사 및 모델명을 입력해보세요." defaultValue="아반" />
						<i className="icon icon_search" />
					</div>

					{/* 검색결과 있을 때 */}
					<div className={`${styles["search-result"]} mt_30`}>
						<div>현대 <span className={styles.focus}>아반</span>떼</div>
						<div>현대 <span className={styles.focus}>아반</span>떼 AD</div>
						<div>현대 <span className={styles.focus}>아반</span>떼 MD</div>
					</div>

					{/* 검색값 데이터 없을 때 */}
					<div className="center-cont no-data-box py_40 mt_30">
						<i className="icon icon_no_data" />
						<p className="mt_20">'아반'에 대한 검색결과가 없어요.<br />검색어를 다시 확인해주세요.</p>
					</div>

					{/* 데이터 없을 때 */}
					<div className="center-cont no-data-box py_40 mt_30">
						<i className="icon icon_no_data" />
						<p className="mt_20">최근 조회한 차량이 없습니다.</p>
					</div>

					<div className="flex-justify_between align_center mt_50">
						<h3>최근 조회차량</h3>
						<span className="text-red">전체삭제</span>
					</div>
					<ul className={`${styles["enquiry-car"]} mt_30`}>
						<li>
							<div className="flex_1 ellipsis">현대 아반떼 AD</div>
							<i className="icon icon_input_close ml_10" />
						</li>
						<li>
							<div className="flex_1 ellipsis">123루 1222</div>
							<i className="icon icon_input_close ml_10" />
						</li>
						<li>
							<div className="flex_1 ellipsis">기아 모하비</div>
							<i className="icon icon_input_close ml_10" />
						</li>
						<li>
							<div className="flex_1 ellipsis">텍스트가 길어질 때 텍스트가 길어질 때 텍스트가 길어질 때</div>
							<i className="icon icon_input_close ml_10" />
						</li>
					</ul>
				</div>
			</div>
			<div className="padding py_30">
				<h3>인기 검색 차량</h3>
				<div className={`${styles["search-pop-list"]} mt_30`}>
					<ul>
						<li>
							<strong className={styles.up}>1</strong> <div className="flex_1 ellipsis">아우디 A6</div>
						</li>
						<li>
							<strong className={styles.up}>2</strong> <div className="flex_1 ellipsis">현대 아반떼 AD</div>
						</li>
						<li>
							<strong className={styles.up}>3</strong> <div className="flex_1 ellipsis">기아 올 뉴 카니발</div>
						</li>
						<li>
							<strong>4</strong> <div className="flex_1 ellipsis">기아 EV6 롱레인지</div>
						</li>
						<li>
							<strong>5</strong> <div className="flex_1 ellipsis">기아 모하비</div>
						</li>
					</ul>
					<ul>
						<li>
							<strong>6</strong> <div className="flex_1 ellipsis">기아 모하비</div>
						</li>
						<li>
							<strong>7</strong> <div className="flex_1 ellipsis">현대 아반떼 AD</div>
						</li>
						<li>
							<strong>3</strong> <div className="flex_1 ellipsis">기아 올 뉴 카니발</div>
						</li>
						<li>
							<strong>4</strong> <div className="flex_1 ellipsis">기아 모하비</div>
						</li>
						<li>
							<strong>5</strong> <div className="flex_1 ellipsis">차량명 텍스트가 길어질 때 차량명 텍스트가 길어질 때</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	)
}

export default FincarSearchEnter